import React, { Component } from "react";
// import Custom Componenets
// import Breadcrumb from '../components/common/breadcrumb.component';
// import paginationFactory from 'react-bootstrap-table2-paginator';
import { Button, Row, Col } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Datetime from "react-datetime";
// import Datepicker from 'react-datepicker';
// import CountUp from 'react-countup';
// import { Chart } from 'react-google-charts';
// import Highcharts, { map } from 'highcharts';
import HighchartsReact from "highcharts-react-official";
import drilldown from "highcharts/modules/drilldown";
// import { CommonLoading } from 'react-loadingg';

// koneksi
import {
  Post,
  Get,
} from "../function/Koneksi";

// css files
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "../assets/css/site.css";

// drilldown(Highcharts);

const frmDef = {
  id: "",
  id_rt: "",
  alamat: ""
};

// const { ExportCSVButton } = CSVExport;

class StatistikSurat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      data_rt: [],
      pagination: [],
      pagination_rt: [],

      tahun_surat: new Date(),

      // Detail
      data_detail: [],
      data_detail_sumber_air: [],
      data_detail_kepemilikan_rumah: [],
      data_detail_penduduk: [],
      data_umur: [],
      pagination_detail: [],
      dataPenduduk: {
        nik: ""
      },

      status: {
        view: false,
        form: false,
        btnForm: false,
        btnAksi: false,
        dataPotensi: false,
        dataPotensi2: false,
        dataPotensi3: false,
        dataPotensi4: false,
        dataPotensi5: false,
        dataPotensi6: false,
        dataPotensi7: false,
        dataPotensi8: false,
        dataPotensi9: false,
        dataPotensi60: false,
        dataPotensi61: false,
        dataPotensi62: false,
        dataPotensi63: false
      },
      status2: {
        view: false,
        form: false,
        btnForm: false,
        btnEdit: false,
        btnDelete: false
      },
      datakk: {
        id: "",
        nama: "",
        tempat_lahir: "",
        nama_ibu_kandung: "",
        nama_ayah_kandung: ""
      },
      active_tab_icon: "1",

      // Pagination
      awal: "",
      sebelum: "",
      hal: [],
      setelah: "",
      akhir: "",

      // Pagination Detail
      awalDetail: "",
      sebelumDetail: "",
      halDetail: [],
      setelahDetail: "",
      akhirDetail: "",

      shdk: [],
      detailshdk: [],
      batasKK: "",
      penduduk_kk_baru: [],
      data_keluarga: [],
      diskk: false,
      tampilkk: "inherit",
      wilayah: "inherit",
      addForm: false,
      addMode: "provinsi",
      addID: "",
      addNama: "",
      frmAnggota: "none",
      detail: [],
      view_kk: "",
      view_penduduk: [],
      dt: frmDef,
      alert: null,
      show: false,
      basicTitle: "",
      basicType: "default",
      pesanAlert: "",
      pekerjaan: [],
      hubungan: [],
      // =========== Select 2 ============
      frmPrv: [],
      prvStat: null,
      frmKbkt: [],
      kbktStat: null,
      frmKec: [],
      kecStat: null,
      frmKel: [],
      kelStat: null,
      dusStat: null,
      frmDus: [],
      frmShdk: [],
      shdkStat: null,
      frmAgm: [],
      agmStat: null,
      frmPtr: [],
      ptrStat: null,
      frmPkr: [],
      pkrStat: null,
      frmKk: [],
      kkStat: null,
      frmStp: [],
      stpStat: null,
      frmJk: [],
      jkStat: null,
      frmSpk: [],
      spkStat: null,
      agmkkStat: null,
      ptrkkStat: null,
      pkrkkStat: null,
      stpkkStat: null,
      jkkkStat: null,
      spkkkStat: null,
      // ============ Tanggal ==============
      startDate: new Date(),
      startDatekk: new Date(),
      // ===================================
      data_penduduk: [],
      statUbah: false,
      pecahKK: false,

      // =========== Data Profil Desa ========
      data_desa: {
        id_keldes: "",
        nama_desa: "",
        kode_desa: "",
        alamat_desa: ""
      },

      // =========== Data Potensi ========
      data_kk_terdaftar: [],
      data_potensi_penduduk: [],
      list_penduduk: [],
      tmp_nik: "",
      filterValue: "",
      // Detail
      urlDetail: null,
      urlPartDetail: "",
      urlCari: "",
      tableDetail: null,
      option_jenis_sumber_air: [],
      option_jenis_kepemilikan_rumah: [],
      option_jenis_kepemilikan_lahan: [],
      option_komoditas: [],
      option_aset: [],
      option_ekonomi: [],
      option_aset_pilihan: [],
      option_galian: [],
      option_agama: [],
      option_pekerjaan: [],
      option_usia: [],
      option_pernikahan: [],

      data_surat: [],
      total_surat: "",
      drilldown_data_surat: []
    };
  }

  tutupAddForm = e => {
    e.preventDefault();
    this.setState({ mode: "provinsi", addID: "", addNama: "", addForm: false });
  };

  // =====================================================
  // ================== Sweet Alert ==================
  closeAlert = () => {
    this.setState({
      show: false
    });
  };

  onRecieveInput = value => {
    this.setState({
      alert: (
        <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
          You wrote: {value}
        </SweetAlert>
      )
    });
  };

  hideAlert = () => {
    this.setState({
      alert: null
    });
  };

  // =================================================

  // ================== Ambil data dari db untuk table ==================
  fetch = (params = {}) => {
    // let link = '';
    // let link_rt = '';
    // let where = [];
    // if (params.where) {
    // 	where = params.where;
    // }
    if (params.page) {
      switch (params.page) {
        case ">>":
          // link = '?page=' + Math.ceil(this.state.pagination.total / this.state.pagination.per_page);
          // link_rt = '?page=' + Math.ceil(this.state.pagination_rt.total / this.state.pagination_rt.per_page);
          break;
        case ">":
          // link = '?page=' + (parseInt(this.state.pagination.current_page) + 1);
          // link_rt = '?page=' + (parseInt(this.state.pagination_rt.current_page) + 1);
          break;
        case "<":
          // link = '?page=' + (parseInt(this.state.pagination.current_page) - 1);
          // link_rt = '?page=' + (parseInt(this.state.pagination_rt.current_page) - 1);
          break;
        case "<<":
          // link = '?page=1';
          // link_rt = '?page=1';
          break;
        default:
          // link = '?page=' + params.page;
          // link_rt = '?page=' + params.page;
          break;
      }
    }
  };

  // =================== End Ambil Data DB ====================

  // ============================= End Pagination ========================
  // =========================== Simpan User =====================================

  // =======================================================================
  // =======================================================================
  // ============================ Cari Data ================================
  // =======================================================================
  // =======================================================================

  // =================== Cari Data Table ====================
  cariData = e => {
    if (e.key === "Enter") {
      let dataPenduduk = {
        q: e.target.value
      };
      Post("potensi-desa/data-masyarakat", null, dataPenduduk, lihat => {
        this.setState({
          data: lihat.data.results.data,
          pagination: lihat.data.results
        });
        this.pagination(lihat.data.results);
      });
    }
  };

  // =================== Cari Detail Penduduk ====================

  // ======================= End Cari Detail Produksi Galian =====================

  // =======================================================================
  // =======================================================================
  // ========================== End Cari Data ==============================
  // =======================================================================
  // =======================================================================

  // ========================================================================

  bukaView = id => {
    Get("kartu-keluarga/keluarga", id, data => {
      this.state.view_kk = id;
      this.state.view_penduduk = data.results;
      this.state.status.view = true;
      this.forceUpdate();
    });
  };

  tutupView = () => {
    this.state.status.view = false;
    this.forceUpdate();
  };

  bukaForm = () => {
    this.state.status.form = true;
    this.forceUpdate();
  };

  tutupForm = () => {
    this.state.status.form = false;
    this.state.agmkkStat = null;
    this.state.pkrkkStat = null;
    this.state.ptrkkStat = null;
    this.state.spkkkStat = null;
    this.state.stpkkStat = null;
    this.state.jkkkStat = null;

    this.state.status.dataPotensi = false;
    this.state.status.dataPotensi2 = false;
    this.state.status.dataPotensi3 = false;
    this.state.status.dataPotensi4 = false;
    this.state.status.dataPotensi5 = false;
    this.state.status.dataPotensi6 = false;
    this.state.status.dataPotensi7 = false;
    this.state.status.dataPotensi8 = false;
    this.state.status.dataPotensi60 = false;
    this.state.status.dataPotensi61 = false;
    this.state.status.dataPotensi62 = false;
    this.state.status.dataPotensi63 = false;

    this.state.data_detail_penduduk = [];
    this.state.urlPartDetail = "";
    this.state.urlCari = "";

    this.state.urlDetail = null;
    this.state.tableDetail = null;
    this.state.filterValue = null;
    this.state.awalDetail = "";
    this.state.halDetail = [];
    this.state.sebelumDetail = "";
    this.state.setelahDetail = "";
    this.state.akhirDetail = "";
    this.state.data_detail = [];

    this.state.dataPenduduk.nik = "";
    // this.componentDidMount();

    this.forceUpdate();
  };

  tombolAksi = (cell, row) => {
    return (
      <div>
        <Button
          size="xs"
          color="success"
          className="btn-icon"
          // onClick={() => this.ubahData(row.id)}
          disabled={this.state.status2.btnEdit}
        >
          <i className="fa fa-pencil" />
        </Button>{" "}
        &nbsp;&nbsp;
        {/* <Button size="xs" color="danger" className="btn-icon" onClick={() => this.konfirmHapus(row.id)} disabled={this.state.status2.btnDelete}><i className="fa fa-trash"></i></Button> */}
      </div>
    );
  };
  formatKalimat(value) {
    // Ganti underscore dengan spasi
    let kalimat = value.replace(/_/g, " ");

    // Split kalimat menjadi kata-kata
    let kataKata = kalimat.split(" ");

    // Kapitalisasi huruf pertama setiap kata
    kataKata = kataKata.map(
      kata => kata.charAt(0).toUpperCase() + kata.slice(1)
    );

    // Gabungkan kata-kata menjadi satu kalimat
    const hasil = kataKata.join(" ");

    return hasil;
  }

  getSurat = tahun => {
    // console.log(this.state.tahun_surat);
    let tahun_surat = tahun.getFullYear();
    // console.log(tahun_surat);
    Get(`surat-keterangan/grup/data/${tahun_surat}`, null, data => {
      let data_surat = [];
      let total_surat = 0;

      if (data.results) {
        console.log("tes");
        for (var [key, value] of Object.entries(data.results.data_grafik)) {
          data_surat.push({
            name: this.formatKalimat(key),
            y: value,
            drilldown: key
          });
        }
        total_surat = data.results.total_surat;
      }
      this.setState({
        data_surat,
        total_surat: total_surat
      });
      console.log("asdmknis", this.state.data_surat);
    });
  };

  componentDidMount() {
    this.getSurat(this.state.tahun_surat);
  }

  highchartStatisticFunction = (data_chart, drilldown_chart, title_chart) => {
    let tahun_surat = this.state.tahun_surat.getFullYear();
    const options = {
      chart: {
        type: "column"
        // scrollablePlotArea: {
        // minWidth: 900,
        // 	scrollPositionX: 1
        // }
      },
      credits: {
        enabled: false
      },
      title: {
        text: title_chart
      },
      xAxis: {
        type: "category",
        // title: {
        // 	text: null
        // },
        labels: {
          events: {
            click: e => {
              console.log("cobaa");
              // <Redirect to="" />
            }
          }
        },
        min: 0,
        max: 4
        // scrollbar: {
        // 	enabled: true
        // },
        // tickLength: 0
      },
      legend: {
        enabled: false
      },
      series: [
        {
          name: "Jumlah Surat pada Tahun " + tahun_surat,
          colorByPoint: true,
          data: data_chart
        }
      ],
      drilldown: {
        series: drilldown_chart
      },
      scrollbar: {
        enabled: true
      }
    };
    return options;
  };

  cekSurat = () => {
    // this.state.data_surat.map(data => {
    //   let jenis_surat = data.drilldown.replace(/_/g, "-")
    //   let toData = {
    //     pathname: "/admin/" + jenis_surat, state: data
    //   }
    //   // let navigate = useNavigate()
    //   return (
    //     <Redirect to={toData} push={true}/>
    //   )
    // })
    // if(this.state.data_surat !== null){
    // //   this.state.data_surat.map(data => {
    // //     let jenis_surat = "";
    // //     let condition = false;
    // //     console.log(LIST_LAYANAN)
    // //     console.log(data.drilldown)
    // //   switch (data.drilldown) {
    // //     case "surat_keterangan_kelahiran":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_kelahiran) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_kuasa_skgr":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_kuasa_skgr) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_pernyataan_belum_menikah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_izin_mendirikan_bangunan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_izin_keramaian":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_izin_keramaian) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_pengantar_skck":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_pengantar_skck) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_domisili":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_domisili) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_kepemilikan_rumah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_kepemilikan_rumah) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_penghasilan":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_penghasilan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_jalan":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_jalan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_gaib":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_gaib) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_persetujuan_mempelai":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_persetujuan_mempelai) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_penyaksian_tanah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_penyaksian_tanah) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_penghasilan_orang_tua":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_penghasilan_orang_tua) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_tidak_mampu":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_tidak_mampu) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_pernyataan_tidak_menikah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_pernyataan_tidak_menikah) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_undangan":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_undangan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_tidak_sengketa":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_tidak_sengketa) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_penguburan":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_izin_mendirikan_bangunan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_perintah_tugas":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_perintah_tugas) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_pindah_datang_wni":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_pindah_datang_wni) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_kematian":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_kematian) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_perintah_perjalanan_dinas":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_perintah_perjalanan_dinas) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_pernah_menikah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_pernah_menikah) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_usaha":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_usaha) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_pernyataan_kehilangan":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_pernyataan_kehilangan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_pengantar_pindah_nikah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_pengantar_pindah_nikah) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_ahli_waris":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_ahli_waris) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "formulir_biodata_penduduk":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_izin_mendirikan_bangunan) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_beda_nama":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_beda_nama) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_kuasa":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_kuasa) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_domisili_usaha":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_domisili_usaha) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "blangko_nikah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.blangko_nikah) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     case "surat_keterangan_pernah_nikah":
    // //       if (LIST_LAYANAN !== null && LIST_LAYANAN.surat_keterangan_pernah_menikah) {
    // //         condition = true;
    // //       }
    // //       break;
    // //     default:
    // //       break;
    // //   }
    // //   jenis_surat = data.drilldown.replace(/_/g,"-")
    // //   let toData = {
    // //     pathname: "/admin/" + jenis_surat, state: data
    // //   }
    // //   console.log(condition)
    // //   console.log(jenis_surat)
    // //   if(condition){
    // //     return(
    // //     <>
    // //         {data.name} : {data.y === 0 ? "-" : data.y}
    // //         <Link
    // //           className="btn btn-xs ml-2 btn-info"
    // //           to={toData}
    // //         >
    // //           <i className="fa fa-eye"></i>
    // //         </Link>
    // //     </>
    // //     )
    // //   }else{
    // //     return(
    // //       <></>
    // //     )
    // //   }
    // // })
    // }
  };
  render() {
    let tahun_surat = this.state.tahun_surat.getFullYear();
    const Highcharts = require("highcharts/highstock");
    drilldown(Highcharts);

    return (
      <div>
        {/* <Breadcrumb title="Data Potensi Masyarakat" parent="Admin" /> */}
        <SweetAlert
          show={this.state.show}
          type={this.state.basicType}
          title={this.state.basicTitle}
          confirmBtnBsStyle="success"
          onConfirm={this.closeAlert}
        >
          {this.state.pesanAlert}
        </SweetAlert>

        {this.state.alert}

        <div className="container-fluid ">
          {/* <div className="row"> */}
          <div className="col-sm-12 justify-content-center">
            <div className="card mb-0 p-5 d-flex">
              <Row>
                <Col sm="12">
                  <Datetime
                    inputProps={{
                      "data-testid": "tahun_surat",
                      placeholder: "Pilih Tahun Yang Akan Ditampilkan"
                    }}
                    inputId="tahun_surat"
                    className="mb-3"
                    name="tahun_surat"
                    locale="id-ID"
                    timeFormat={false}
                    dateFormat="YYYY"
                    input={true}
                    closeOnTab={true}
                    initialValue={this.state.tahun_surat}
                    value={this.state.tahun_surat}
                    onChange={date => {
                      if (typeof date._isValid !== "undefined") {
                        let formattahun = date.format("YYYY-MM-DD");
                        let tahun = new Date(formattahun);
                        this.setState({
                          tahun_surat: tahun,
                          data_surat: [],
                          drilldown_data_surat: []
                        });
                        console.log(this.state.tahun_surat);
                        this.getSurat(tahun);
                      }
                      // this.componentDidMount();
                    }}
                  />
                </Col>
                {this.state.total_surat !== 0 ? (
                  <>
                    <Col sm="12">
                      <div className="card p-3 text-center">
                        <h5 className="card-title text-capitalize text-center">
                          Total Surat : {this.state.total_surat}
                        </h5>
                      </div>
                    </Col>
                    <Col sm="12">
                      <div className="card p-3">
                        <HighchartsReact
                          highcharts={Highcharts}
                          options={this.highchartStatisticFunction(
                            this.state.data_surat,
                            this.state.drilldown_data_surat,
                            "Data Statistik Surat Tahun " + tahun_surat
                          )}
                          // style={{ width: "100%" }}
                          className="justify-content-center"
                        />
                      </div>
                    </Col>
                    <Col sm="12">
                      <div className="card p-3">
                        <div className="card-header">
                          <h5 className="card-title text-capitalize text-center">
                            Data Jumlah Surat Tahun {tahun_surat}
                          </h5>
                        </div>
                        <div className="row card-body">
                          {/* <div className="col-xl-4 col-md-6 col-sm-12 p-2" key={ Math.random().toString(36).substr(2, 9) }>
                          {this.cekSurat()}
                        </div> */}
                          {this.state.data_surat.map(data => {
                            // let baseurl = "admin/";
                            // console.log('data surat')
                            // console.log(data)
                            let jenis_surat = data.drilldown.replace(/_/g, "-");
                            console.log(jenis_surat);
                            return (
                              <div className="col-xl-4 col-md-6 col-sm-12 p-2">
                                {data.name} : {data.y === 0 ? "-" : data.y}
                                {/* <Button
                                  size="xs"
                                  color="info"
                                  className="btn-icon ml-2 btn-success justify-self-end"
                                  onClick={
                                    () => this.props.history.push(toData)
                                  }
                                >
                                  <i className="fa fa-eye"></i>
                                </Button> */}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </Col>
                  </>
                ) : (
                  <div className="card w-100 p-5">
                    <div className="text-center">
                      === Data Tidak Ditemukan ===
                    </div>
                  </div>
                )}
              </Row>

              {/* </TabPane> */}
              {/* </TabContent> */}
              {/* </div> */}
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    );
  }
}

export default StatistikSurat;
